export default __webpack_public_path__ + "static/anticorruption-practices-banner-fe956931427e6667081f64fc624127da.png";